import React from 'react'
import { Container } from '_themes/default/components/styled/login-register'

const LoginRegister = ({ children }) => <Container>{children}</Container>

export default LoginRegister
